import { ComponentType, FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useGetStorageStatsQuery } from '~/api/v2/hooks';
import { ButtonSpinner } from '~/components';
import { FilesIcon, FoldersIcon, StorageIcon } from '~/icons';
import { IconComponentsProps } from '~/icons/types';
import { formatBytes } from '~/utils';
import { storageStatBlockStyles, storageStatIconStyles } from './styles';

export enum StorageStatsEnum {
  SIZE = 'size',
  FILE_COUNT = 'file_count',
  FOLDER_COUNT = 'folder_count',
}

const statsConfig: Record<
  StorageStatsEnum,
  {
    Icon: ComponentType<IconComponentsProps>;
    title: string;
    formatValue?: (value: number) => string;
  }
> = {
  size: {
    Icon: StorageIcon,
    title: 'Storage used',
    formatValue: formatBytes,
  },
  file_count: {
    Icon: FilesIcon,
    title: 'Total files',
  },
  folder_count: {
    Icon: FoldersIcon,
    title: 'Folders',
  },
};

interface StorageStatBlock {
  type: StorageStatsEnum;
}

const StorageStatBlock: FC<StorageStatBlock> = ({ type }) => {
  const { Icon, title } = statsConfig[type];
  const formatValue = statsConfig[type]?.formatValue;
  const { data, isLoading } = useGetStorageStatsQuery({});

  return (
    <Box sx={storageStatBlockStyles}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack>
          <Typography variant="bodyS" color="textBlackReduced.main">
            {title}
          </Typography>
          {!data || isLoading ? (
            <ButtonSpinner />
          ) : (
            <Typography color="text.primary">{formatValue?.(data[type]) || data[type]}</Typography>
          )}
        </Stack>
        <Icon style={storageStatIconStyles} />
      </Stack>
    </Box>
  );
};

export default StorageStatBlock;
